import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";
import BasicThemeJson from "./ThemePropertiesJson/BasicThemeJson";
import DropdownComponent from "./DropdownComponent";
import LayoutComponent from "./LayoutComponent";
import clsx from 'clsx';
import ColorPallete from "./ColorPallete";
import Autocomplete from "@material-ui/lab/Autocomplete";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CloseIcon from "@material-ui/icons/Close";
import {TextField,InputAdornment,IconButton} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import ColorPicker from "../../../../../ReusableComponents/ColorPicker/ColorPicker";
import EditableColorPallete from "./EditableColorPallete";
import st from "./customFile.css";
import { useDispatch, addContexts, useSelector } from "../../../../../Redux";
import { generateColor } from "../../.././../../Resources/ColorGenerator";
import { useTranslation } from "react-i18next";
import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { GetStateFromData } from "../../../../CustomHooks/CustomHooks";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@material-ui/core"
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SectionOuterMargin from "../../../../../Icons/SectionOuterMargin.jsx"
import SectionInnerPadding from "../../../../../Icons/SectionInnerPadding.jsx"
import ControlSpacing from "../../../../../Icons/ControlSpacing.jsx"

const theme = createTheme({
  direction: "rtl",
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSlider-thumb": {
      marginRight: -5,
      marginLeft: 0,
    },
  },
  paper: {
    boxShadow: "0 3px 6px rgba(0, 0, 0, 0.5) !important",
    outline: "1px solid #c4c4c4 !important",
    maxHeight: "269px",
  },
  auto:{
      padding: 0,
      border: "1px solid #C4C4C4",
      "& .MuiChip-root": {
        borderRadius: 2,
        width: "90px",
        height: "25px",
        backgroundColor: "#F0F0F0",
      },
      "& .MuiButtonBase-root": {
        margin: "0 !important",
      },
      "& .MuiInputBase-input": {
        border: "none !important",
        flexGrow: "0",
        width: "0px !important",
        minWidth: "90px !important",
      },
  
      "& .MuiAutocomplete-endAdornment": {
        right:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "unset"
            : null,
        left:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "-183px"
            : null,
      },
      "& .MuiChip-deleteIcon": {
        marginRight:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "unset"
            : null,
        marginLeft:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "5px"
            : null,
      },
    },
  inputRoot: {
    "& .MuiOutlinedInput-root": {
      "& .MuiAutocomplete-endAdornment": {
        right:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "unset"
            : null,
        left:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "9px"
            : null,
      },
      "& .MuiAutocomplete-inputRoot": {
        paddingRight: "unset !important",
      },
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none !important",
    },
    "& div.MuiFormControl-root div.MuiInputBase-root.MuiInput-root input#tags-filled.MuiInputBase-input.MuiInput-input.MuiAutocomplete-input[aria-autocomplete=list]:not(#canvasId *):focus" :{
      border:"none !important",
      borderColor:"#ed702d !important"
      },
    "& .MuiInput-underline:not(.Mui-disabled):before": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "0px solid rgba(0, 0, 0, 0.42) !important", // Fixed the 'px' typo
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingRight: "unset !important",
    },
    // "& .MuiAutocomplete-clearIndicator": {
    //   display: "none",
    // },
  },
  radioroot: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
  accordionSummaryExpanded: {
    minHeight: "37px !important",
  },
  accordionSummaryRoot: {
    minHeight: "37px !important",
    margin: "0 !important",
    color:"#000000 !important",
    fontWeight:"600"
  },
  accordionExpanded: {
    margin: "0 !important"
  },
  accordionSummaryContent: {
    alignItems: "center",
     margin: "0 !important"
  }

}));
// const classes = useStyles();
const BasicTheme = (props) => {
  const { t } = useTranslation(["styles", "translation"]);
  const translationStyles =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
    const classes = useStyles();
  const contexts = GetStateFromData(props.containerId);
  const { updateJson, formState2,showAlertConfirmNotifications} = contexts.contexts;
  const isProcessForm = window.location.href.includes("psh/pmWebDesigner");
  const { updatedComponentInFormState } = updateJson;
  const [selectedOption, setSelectedOption] = useState('');
  const [state, setState] = React.useState(16);
  const [customValue, setCustomValue] = useState("16");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isHovered, setIsHovered] = useState(false);
  const [isHovered_h, setIsHovered_h] = useState(false);

  const [isHoveredInnerleft, setisHoveredInnerleft] = useState(false);
  const [isHoveredInnerright, setisHoveredInnerright] = useState(false);
  const [isHoveredInnertop, setisHoveredInnertop] = useState(false);
  const [isHoveredInnerbottom, setisHoveredInnerbottom] = useState(false);

  const [isHovspacingleft, setisHovspacingleft] = useState(false);
  const [isHovspacingright, setisHovspacingright] = useState(false);
  const [isHovspacingtop, setisHovspacingtop] = useState(false);
  const [isHovspacingbottom, setisHovspacingbottom] = useState(false);

  const [inputValue, setInputValue] = useState('');

  const defaultValue = '16';
  const [selectedColor, setSelectedColor] = useState(
    props.selectedTheme &&
      props.selectedTheme["BasicTheme"] &&
      props.selectedTheme["BasicTheme"]["PrimaryColor"]
      ? props.selectedTheme["BasicTheme"]["PrimaryColor"]
      : "#685AC0"
  );
  const [colorPalleteColors, setColorPalleteColors] = useState(
    formState2?.theme?.BasicTheme?.colorPallete
      ? formState2.theme.BasicTheme.colorPallete
      : BasicThemeJson && BasicThemeJson["ColorPallete"]
      ? BasicThemeJson["ColorPallete"]
      : [
          {
            colorName: "Black",
            colorCode: "#222222",
            backgroundcolor: "#222222  ",
            borderRadius: "2px 0px 0px 2px",
          },
          {
            colorName: "Dark Grey",
            colorCode: "#4D4D4D",
            backgroundcolor: "#4D4D4D  ",
          },
          {
            colorName: "Light Grey",
            colorCode: "#E0E0E0",
            backgroundcolor: "#E0E0E0  ",
          },
          {
            colorName: "White",
            colorCode: "#FFFFFF",
            backgroundcolor: "#FFFFFF  ",
          },
          {
            colorName: "Tint 2 of Primary",
            colorCode: "#685AC014",
            backgroundcolor: "#685AC014  ",
          },
          {
            colorName: "Tint 1 of Primary",
            colorCode: "#685AC029",
            backgroundcolor: "#685AC029  ",
          },
          {
            colorName: "Secondary",
            colorCode: "#AE2BC6",
            backgroundcolor: "#AE2BC6  ",
          },
          {
            colorName: "Primary",
            colorCode: "#685AC0",
            backgroundcolor: "#685AC0  ",
            borderRadius: "0px 2px 2px 0px",
          },
        ]
  );
  const accordianStyle={backgroundColor:"#E6E6EB",fontWeight:"600",fontSize:"14px"}
  const handleCustomInputChange = (event) => {
    setCustomValue(event.target.value);
    setSelectedOption(''); // Clear selected option when custom value is entered
  };

  const [showColorPalleteEditable, setShowColorPalleteEditable] =
    useState(false);

  function handleChange(ev, value, key) {
    if (key) {
      props.selectedTheme["BasicTheme"][key] = translationStyles
        ? 27 - value
        : value;
    } else {
      if (
        props.selectedTheme?.["BasicTheme"] &&
        props.selectedTheme?.["BasicTheme"]?.["FontSize"]
      ) {
        props.selectedTheme["BasicTheme"]["FontSize"] = translationStyles
          ? 27 - value + "px"
          : value + "px";
      } else {
        props.selectedTheme["BasicTheme"] = {};
        props.selectedTheme["BasicTheme"]["FontSize"] = translationStyles
          ? 27 - value + "px"
          : value + "px";
      }
    }
    var basicThemeVar = { ...props.selectedTheme["BasicTheme"] };
    props.selectedTheme["BasicTheme"] = basicThemeVar;
    props.showThemechanges(props.selectedTheme);
  }
  function addOpacity(color, opacityPercentage) {
    var opacity = opacityPercentage / 100;
    const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);

    return color + _opacity.toString(16).toUpperCase();
  }
  function getComplementaryColor(hexValue) {
    try {
      var rgbResult;

      if (hexValue.length === 7) {
        rgbResult = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexValue);
      } else if (hexValue.length === 9) {
        rgbResult =
          /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
            hexValue
          );
      }

      if (rgbResult) {
        var rValue = parseInt(rgbResult[1], 16);
        var gValue = parseInt(rgbResult[2], 16);
        var bValue = parseInt(rgbResult[3], 16);
        var complementaryRValue =
          Math.max(rValue, gValue, bValue) +
          Math.min(rValue, gValue, bValue) -
          rValue;
        var complementaryGValue =
          Math.max(rValue, gValue, bValue) +
          Math.min(rValue, gValue, bValue) -
          gValue;
        var complementaryBValue =
          Math.max(rValue, gValue, bValue) +
          Math.min(rValue, gValue, bValue) -
          bValue;
        var complementaryHexValue =
          "#" +
          (
            (1 << 24) +
            (complementaryRValue << 16) +
            (complementaryGValue << 8) +
            complementaryBValue
          )
            .toString(16)
            .slice(1);
        return complementaryHexValue;
      }
    } catch (e) {
      console.log("Error while generating complmentary color.");
    }
  }

  function generateRandomColor() {
    const randomColorG =
      "#" + Math.floor(Math.random() * 16777215).toString(16);

    if (randomColorG.length === 7 || randomColorG.length === 9) {
      return randomColorG;
    } else {
      return generateRandomColor();
    }
  }

  function validateArgs(color1 = "", color2 = "") {
    let colors = { arg2: color1, arg3: color2 };

    if (color1) {
      if (color1.length !== 7 && color1.length !== 9) {
        colors.arg2 = generateRandomColor();
      }
    } else {
      colors.arg2 = generateRandomColor();
    }

    if (color2) {
      if (color2.length !== 7 && color2.length !== 9) {
        colors.arg3 = generateRandomColor();
      }
    } else {
      colors.arg3 = generateRandomColor();
    }

    return colors;
  }

  function generateNewColor() {
    var randomColor = generateRandomColor();
    var randomColor1 = generateRandomColor();
    generateColorPallete("", randomColor, randomColor1);
  }

  function generateColorPallete(arg1, argt2, argt3) {
    const { arg2, arg3 } = validateArgs(argt2, argt3);

    setSelectedColor(arg2);

    var complementaryColor = getComplementaryColor(arg2);
    var complementaryColor1 = getComplementaryColor(arg3);
    var tint1 = colorPalleteColors[4];
    tint1["backgroundColor"] = addOpacity(arg2, 8);
    var tint2 = colorPalleteColors[5];
    tint2["backgroundColor"] = addOpacity(arg2, 16);
    var compColor = colorPalleteColors[6];
    compColor["backgroundColor"] = complementaryColor;
    var primaryColor = colorPalleteColors[7];
    primaryColor["backgroundColor"] = arg2;

    var tint3 = colorPalleteColors[0];
    tint3["backgroundColor"] = addOpacity(arg3, 8);
    var tint4 = colorPalleteColors[1];
    tint4["backgroundColor"] = addOpacity(arg3, 16);
    var compColor1 = colorPalleteColors[2];
    compColor1["backgroundColor"] = complementaryColor1;
    var primaryColor1 = colorPalleteColors[3];
    primaryColor1["backgroundColor"] = arg3;
    var colorPallete = [
      tint1,
      tint2,
      compColor,
      primaryColor,
      tint3,
      tint4,
      compColor1,
      primaryColor1,
    ];
    setColorPalleteColors(colorPallete);
    setHeaderColor(colorPallete, arg2);

    props.showThemechanges(props.selectedTheme);
  }
  function setHeaderColor(colorPallete, color) {
    if (props.selectedTheme) {
      if (props.selectedTheme["BasicTheme"]) {
        props.selectedTheme["BasicTheme"]["colorPallete"] = colorPallete;
      } else {
        props.selectedTheme["BasicTheme"] = {};
        props.selectedTheme["BasicTheme"]["PresetColors"] =
          BasicThemeJson["PresetColors"];
        props.selectedTheme["BasicTheme"]["colorPallete"] = colorPallete;
      }
      var presetColors = [];
      colorPallete.map((color) => {
        return presetColors.push(color.backgroundColor);
      });
      props.selectedTheme["BasicTheme"]["PresetColors"] = presetColors;
      props.selectedTheme["BasicTheme"]["PrimaryColor"] = color;
    }
  }
  function handleProperty(themeKey, propertyName, propertyValue,propertyName2,propertyName3) {
    let tempCustomSpacing = {}
    if (props.selectedTheme) {
      if (themeKey === "TabSheetStyle") {
        if (
          props.selectedTheme["HorizontalTabStyle"] &&
          props.selectedTheme["HorizontalTabStyle"]["ActiveTabBackColor"]
        ) {
          props.selectedTheme["HorizontalTabStyle"]["ActiveTabBackColor"] =
            propertyValue;
        } else {
          props.selectedTheme["HorizontalTabStyle"] = {};
          props.selectedTheme["HorizontalTabStyle"]["ActiveTabBackColor"] =
            propertyValue;
        }
      } else if (
        themeKey === "SectionStyle" &&
        propertyName === "SectionHeaderColor"
      ) {
        props.selectedTheme["BasicTheme"]["HeaderBackColor"] = propertyValue;
      } else if (themeKey === "ButtonStyle") {
        if (props.selectedTheme["ButtonStyle"]) {
          if (props.selectedTheme["ButtonStyle"]["ControlStyle"]) {
            if (
              props.selectedTheme["ButtonStyle"]["ControlStyle"] !==
                "Secondary" &&
              props.selectedTheme["ButtonStyle"]["ControlStyle"] !== "Text"
            ) {
              props.selectedTheme["ButtonStyle"][
                "PrimaryButtonBackgroundColor"
              ] = propertyValue;
            }
          } else {
            props.selectedTheme["ButtonStyle"]["PrimaryButtonBackgroundColor"] =
              propertyValue;
          }
        } else {
          props.selectedTheme["ButtonStyle"] = {};
          props.selectedTheme["ButtonStyle"]["PrimaryButtonBackgroundColor"] =
            propertyValue;
        }
      } else if (themeKey === "SlideBarStyle") {
        if (
          props.selectedTheme["SliderTheme"] &&
          props.selectedTheme["SliderTheme"]["SlideBarHeader"]
        ) {
          props.selectedTheme["SliderTheme"]["SlideBarHeader"] = propertyValue;
        } else {
          props.selectedTheme["SliderTheme"] = {};
          props.selectedTheme["SliderTheme"]["SlideBarHeader"] = propertyValue;
        }
      } else if (themeKey === "ActiveStateStyle") {
        if (props.selectedTheme["ToggleStates"]) {
          props.selectedTheme["ToggleStates"]["ActiveStyle"] = propertyValue;
        } else {
          props.selectedTheme["ToggleStates"] = {};
          props.selectedTheme["ToggleStates"]["ActiveStyle"] = propertyValue;
        }
      } else if (themeKey === "InactiveStateStyle") {
        if (props.selectedTheme["ToggleStates"]) {
          props.selectedTheme["ToggleStates"]["InActiveStyle"] = propertyValue;
        } else {
          props.selectedTheme["ToggleStates"] = {};
          props.selectedTheme["ToggleStates"]["InActiveStyle"] = propertyValue;
        }
      } else if (
        themeKey === "BasicTheme" &&
        propertyName === "ActiveTextColor"
      ) {
        if (props.selectedTheme["BasicTheme"]) {
          props.selectedTheme["BasicTheme"][propertyName] = propertyValue;
        } else {
          props.selectedTheme["BasicTheme"] = {};
          props.selectedTheme["BasicTheme"][propertyName] = propertyValue;
        }
      } else if (themeKey === "BasicTheme" && propertyName === "Spacing") {
        if (props.selectedTheme["BasicTheme"]) {
          props.selectedTheme["BasicTheme"][propertyName] = propertyValue;
        } else {
          props.selectedTheme["BasicTheme"] = {};
          props.selectedTheme["BasicTheme"][propertyName] = propertyValue;
        }
      } else if (
        themeKey === "BasicTheme" &&
        propertyName === "InactiveTextColor"
      ) {
        if (props.selectedTheme["InputStyle"]) {
          props.selectedTheme["InputStyle"]["DisabledFontColor"] =
            propertyValue;
        } else {
          props.selectedTheme["InputStyle"] = {};
          props.selectedTheme["InputStyle"]["DisabledFontColor"] =
            propertyValue;
        }
      } else if (
        themeKey === "BasicTheme" &&
        propertyName === "TabSelectionsHeaderColor"
      ) {
          props.selectedTheme["BasicTheme"]["TabSelectionsHeaderColor"] = propertyValue;
      }
       else if (themeKey === "PageStyle") {
        if (props.selectedTheme["PageStyle"]) {
          props.selectedTheme["PageStyle"]["backgroundColor"] = propertyValue;
        } else {
          props.selectedTheme["PageStyle"] = {};
          props.selectedTheme["PageStyle"]["backgroundColor"] = propertyValue;
        }
      } else if (
        themeKey === "SectionStyle" &&
        propertyName === "SectionBackgroundColor"
      ) {
        if (props.selectedTheme["SectionStyle"]) {
          props.selectedTheme["SectionStyle"]["SectionBackColor"] =
            propertyValue;
        } else {
          props.selectedTheme["SectionStyle"] = {};
          props.selectedTheme["SectionStyle"]["SectionBackColor"] =
            propertyValue;
        }
      } else if (
        themeKey === "WizardStyle" &&
        propertyName === "WizardBackgroundColor"
      ) {
        if (props.selectedTheme["WizardStyle"]) {
          props.selectedTheme["WizardStyle"]["WizardBackgroundColor"] =
            propertyValue;
        } else {
          props.selectedTheme["WizardStyle"] = {};
          props.selectedTheme["WizardStyle"]["WizardBackgroundColor"] =
            propertyValue;
        }
      } else if (
        themeKey === "WizardStyle" &&
        propertyName === "WizardSelecion"
      ) {
        if (props.selectedTheme["WizardStyle"]) {
          props.selectedTheme["WizardStyle"]["WizardHeaderBackColor"] =
            propertyValue;
        } else {
          props.selectedTheme["WizardStyle"] = {};
          props.selectedTheme["WizardStyle"]["WizardHeaderBackColor"] =
            propertyValue;
        }
      } else if (themeKey === "HorizontalTabStyle") {
        if (props.selectedTheme["HorizontalTabStyle"]) {
          props.selectedTheme["HorizontalTabStyle"]["BackColor"] =
            propertyValue;
        } else {
          props.selectedTheme["HorizontalTabStyle"] = {};
          props.selectedTheme["HorizontalTabStyle"]["BackColor"] =
            propertyValue;
        }
      } else if (themeKey === "TileStyle") {
        if (props.selectedTheme["TileStyle"]) {
          props.selectedTheme["TileStyle"]["TileBackColor"] = propertyValue;
        } else {
          props.selectedTheme["TileStyle"] = {};
          props.selectedTheme["TileStyle"]["TileBackColor"] = propertyValue;
        }
       
      }
      else if (themeKey === "BasicTheme" &&
      propertyName3 === "Custom Spacing")
      { if (propertyValue < 0) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("Entered Value should not be less than 0")}`
        });
        propertyValue = "0";
      }
      else if (propertyValue > 200) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("Entered Value should not be greater than 200")}`
        });
        propertyValue = "200";
       
      }
        if (props.selectedTheme[propertyName]) {
          props.selectedTheme[propertyName][propertyName2] = propertyValue;
          tempCustomSpacing = { ...props.selectedTheme[propertyName]}
        } else {
          props.selectedTheme[propertyName] = {};
          props.selectedTheme[propertyName][propertyName2] = propertyValue;
          tempCustomSpacing = { ...props.selectedTheme[propertyName]}
        }
        
      }
      if(Object.keys(tempCustomSpacing).length !==0){
        props.selectedTheme[propertyName]=tempCustomSpacing
      }
      var tempThemeVar = { ...props.selectedTheme[themeKey] };
      props.selectedTheme[themeKey] = tempThemeVar;
      props.showThemechanges(props.selectedTheme);
    }
  }

  const handleSpacingType = (e) => {
    const value = e.target.value;
    props.selectedTheme["SpacingType"] = value;

    if(value === "Default Spacing") {
      if(props?.selectedTheme?.["Section Spacing"]) {
        props.selectedTheme["Section Spacing"] = {};
      }
      if(props?.selectedTheme?.["Control Spacing"]) {
        props.selectedTheme["Control Spacing"] = {};
      }
    } else{
     if(value === "Custom Spacing"){
      let spacingColumn = props?.selectedTheme?.["BasicTheme"]?.['Spacing'];
      if (!props.selectedTheme["Control Spacing"]) {
        props.selectedTheme["Control Spacing"] = {};
      }
      if(spacingColumn === "Compressed") {
        props.selectedTheme["Control Spacing"]["Spacing Left"] = '8';
        props.selectedTheme["Control Spacing"]["Spacing Right"] = '8';
        props.selectedTheme["Control Spacing"]["Spacing Top"] = '2';
        props.selectedTheme["Control Spacing"]["Spacing Bottom"] = '2';
      }
      else if(spacingColumn === "Compact") {
        props.selectedTheme["Control Spacing"]["Spacing Left"] = '8';
        props.selectedTheme["Control Spacing"]["Spacing Right"] = '8';
        props.selectedTheme["Control Spacing"]["Spacing Top"] = '4';
        props.selectedTheme["Control Spacing"]["Spacing Bottom"] = '4';
      }
      else if(spacingColumn === "Regular") {
        props.selectedTheme["Control Spacing"]["Spacing Left"] = '8';
        props.selectedTheme["Control Spacing"]["Spacing Right"] = '8';
        props.selectedTheme["Control Spacing"]["Spacing Top"] = '12';
        props.selectedTheme["Control Spacing"]["Spacing Bottom"] = '12';
      }
      else if(spacingColumn === "Expand") {
        props.selectedTheme["Control Spacing"]["Spacing Left"] = '12';
        props.selectedTheme["Control Spacing"]["Spacing Right"] = '12';
        props.selectedTheme["Control Spacing"]["Spacing Top"] = '12';
        props.selectedTheme["Control Spacing"]["Spacing Bottom"] = '12';
      }
      else if(spacingColumn === "Spacious") {
        props.selectedTheme["Control Spacing"]["Spacing Left"] = '16';
        props.selectedTheme["Control Spacing"]["Spacing Right"] = '16';
        props.selectedTheme["Control Spacing"]["Spacing Top"] = '16';
        props.selectedTheme["Control Spacing"]["Spacing Bottom"] = '16';
      }

      if(props?.selectedTheme?.["Default Spacing"]) {
        props.selectedTheme["Default Spacing"] = {};
      }
     }

    }

    props.showThemechanges(props.selectedTheme);
  }

  function handleBackdrop(action, actionObj) {
    if (action === "save") {
      if (
        props.selectedTheme &&
        props.selectedTheme["BasicTheme"] &&
        actionObj
      ) {
        props.selectedTheme["BasicTheme"]["PrimaryColor"] =
          actionObj[actionObj.length - 1] &&
          actionObj[actionObj.length - 1]["backgroundColor"];
        props.selectedTheme["BasicTheme"]["colorPallete"] = actionObj;
        setSelectedColor(
          actionObj[actionObj.length - 1] &&
            actionObj[actionObj.length - 1]["backgroundColor"]
        );
        setColorPalleteColors(actionObj);
        var presetColors = [];
        actionObj.map((color) => {
          return presetColors.push(color.backgroundColor);
        });
        props.selectedTheme["BasicTheme"]["PresetColors"] = presetColors;
      }
      setShowColorPalleteEditable(false);
    } else if (action === "cancel") {
      setShowColorPalleteEditable(false);
    }
  }

  return (
    <div className={style.themeaccordion} style={{
        height: isProcessForm
          ? `calc(100vh - 56px - ${props?.headerHeight}px)`
          : `calc(100vh - 48px - 56px - ${props?.headerHeight}px)`
      }}>
        <Accordion defaultExpanded classes={{ root: classes.accordionExpanded }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}
        classes={{ expanded: classes.accordionSummaryExpanded, root: classes.accordionSummaryRoot, content: classes.accordionSummaryContent }}
          aria-controls="panel1-content" style={accordianStyle}
          id="panel1-header">{t("Color")}</AccordionSummary>
      <Col
        className={[style.basicThemeMainDiv].join(" ")}
      >
        <Row className={[style.primaryColorMainDiv].join(" ")}>
          <Col className={[style.primaryColorText].join(" ")}>
            {t("translation:Primary Color(Brand Color)")}
          </Col>
          <Col className={style.headerBackgroundColorBoxCol1}>
            <input
              type="text"
              aria-label="Primary Color"
              key={
                props?.selectedTheme &&
                props?.selectedTheme?.["BasicTheme"] &&
                props?.selectedTheme?.["BasicTheme"]["PrimaryColor"]
                  ? props?.selectedTheme?.["BasicTheme"]["PrimaryColor"]
                  : selectedColor
              }
              defaultValue={
                props?.selectedTheme &&
                props?.selectedTheme?.["BasicTheme"] &&
                props?.selectedTheme?.["BasicTheme"]["PrimaryColor"]
                  ? props?.selectedTheme?.["BasicTheme"]["PrimaryColor"]
                  : selectedColor
              }
              className={style.primaryColorInputBox}
              onChange={(event) =>
                generateColorPallete("PrimaryColor", event.target.value)
              }
            />
            <div
              className={style.headerBackgroundColorBox}
              style={
                translationStyles
                  ? { marginLeft: "unset", marginRight: "auto" }
                  : null
              }
            >
              <ColorPicker
                key={
                  props?.selectedTheme &&
                  props?.selectedTheme?.["BasicTheme"] &&
                  props?.selectedTheme?.["BasicTheme"]["PrimaryColor"]
                    ? props?.selectedTheme?.["BasicTheme"]["PrimaryColor"]
                    : selectedColor
                }
                color={
                  props?.selectedTheme &&
                  props?.selectedTheme?.["BasicTheme"] &&
                  props?.selectedTheme?.["BasicTheme"]["PrimaryColor"]
                    ? props?.selectedTheme?.["BasicTheme"]["PrimaryColor"]
                    : selectedColor
                }
                presetColors={
                  props?.selectedTheme?.["BasicTheme"] &&
                  props?.selectedTheme?.["BasicTheme"]?.["PresetColors"]
                    ? props.selectedTheme?.["BasicTheme"]?.["PresetColors"]
                    : BasicThemeJson?.["PresetColors"]
                }
                propertyName={"PrimaryColor"}
                sketchPickerCustomStyle={
                  translationStyles
                    ? { position: "absolute", left: "0px", zIndex: 1 }
                    : { position: "absolute", right: "0px" }
                }
                colorPickerInnerBoxStyle={{
                  width: "18px",
                  height: "18px",
                  padding: "0px",
                  border: "none",
                  borderRadius: "none",
                  margin: "0px",
                }}
                colorPickerInputStyle={{ display: "none" }}
                handleProperty={(arg1, arg2) =>
                  generateColorPallete(arg1, arg2)
                }
              />
            </div>
          </Col>
        </Row>
        <Row className={[style.colorPalleteEditRow].join(" ")}>
          <Col className={[style.primaryColorText].join(" ")}>
            {t("translation:Color palette")}
          </Col>
          <Col className={[style.colorPalleteEditCol].join(" ")}>
            <img
              src={require("../../../../../Icons/ColorPalette.svg").default}
              alt="Edit"
              style={{
                width: "16px",
                height: "16px",
                marginLeft: "auto",
                marginRight: "10px",
              }}
              onClick={() => setShowColorPalleteEditable(true)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setShowColorPalleteEditable(true);
                }
              }}
              tabIndex="0"
            />
          </Col>
        </Row>
        <ColorPallete
          colorPalletBoxStyle={
            props?.selectedTheme &&
            props?.selectedTheme?.["BasicTheme"] &&
            props?.selectedTheme?.["BasicTheme"]["colorPallete"]
              ? props?.selectedTheme?.["BasicTheme"]["colorPallete"]
              : colorPalleteColors
          }
        />
        <Row className={[style.generateColorPalleteRow].join(" ")}>
          <Col className={style.generateNewColorPalleteButtonCol}>
            <Button
              disableFocusRipple
              disableRipple
              tabIndex={0}
              className={`${style.generateNewColorPalleteButton} formBuilder-MuiButton-outlined`}
              onClick={() => generateNewColor()}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  generateNewColor();
                }
              }}
            >
              {t("translation:Generate New")}
            </Button>
          </Col>
        </Row>
        {BasicThemeJson && BasicThemeJson["HeaderColor"] ? (
          BasicThemeJson["HeaderColor"].map((details, index) => {
            return (
              <DropdownComponent
                headerBackgroundColor="true"
                propertyName={details.key}
                selectedOption={
                  details.themeKey === "BasicTheme" && details?.key === "TabSelectionsHeaderColor"
                    ? props.selectedTheme?.BasicTheme?.TabSelectionsHeaderColor
                    : details.themeKey === "TabSheetStyle"
                    ? props.selectedTheme?.HorizontalTabStyle?.ActiveTabBackColor
                    : details.themeKey === "SectionStyle"
                    ? props.selectedTheme?.BasicTheme?.HeaderBackColor
                    : details.themeKey === "ButtonStyle"
                    ? props.selectedTheme?.ButtonStyle?.PrimaryButtonBackgroundColor
                    : details.themeKey === "ActiveStateStyle"
                    ? props.selectedTheme?.ToggleStates?.ActiveStyle
                    : details.themeKey === "InactiveStateStyle"
                    ? props.selectedTheme?.ToggleStates?.InActiveStyle
                    : details.themeKey === "WizardStyle"
                    ? props.selectedTheme?.WizardStyle?.WizardHeaderBackColor
                    : details.themeKey === "SlideBarStyle"
                    ? props.selectedTheme?.SliderTheme?.SlideBarHeader
                    : ""
                }
                propertyDetails={details}
                presetColors={
                  props.selectedTheme["BasicTheme"] &&
                  props.selectedTheme["BasicTheme"]["PresetColors"]
                    ? props.selectedTheme["BasicTheme"]["PresetColors"]
                    : BasicThemeJson["PresetColors"]
                }
                handleProperty={(themeKey, arg1, arg2) =>
                  handleProperty(themeKey, arg1, arg2)
                }
              />
            );
          })
        ) : (
          <></>
        )}
        {BasicThemeJson && BasicThemeJson["GroupedColor"] ? (
          BasicThemeJson["GroupedColor"].map((details, index) => {
            return (
              <div className={style.groupedColorParentDiv}>
                {Object.keys(details).map((key, index) => {
                  return (
                    <>
                      <Col className={key==="Background Color" ? style.headerBackgoundDecriptionTitle1: style.headerBackgoundDecriptionTitle}>
                        {t(`translation:${key}`)}
                      </Col>
                      {details[key].map((subDetails, index) => {
                        return (
                          <DropdownComponent
                            groupedColor="true"
                            propertyDetails={subDetails}
                            presetColors={
                              props.selectedTheme["BasicTheme"] &&
                              props.selectedTheme["BasicTheme"]["PresetColors"]
                                ? props.selectedTheme["BasicTheme"][
                                    "PresetColors"
                                  ]
                                : BasicThemeJson["PresetColors"]
                            }
                            selectedOption={
                              subDetails.key === "ActiveTextColor"
                                ? props.selectedTheme?.BasicTheme
                                    ?.ActiveTextColor
                                : subDetails.key === "InactiveTextColor"
                                ? props.selectedTheme?.InputStyle
                                    ?.DisabledFontColor
                                : subDetails.key === "PageBackgroundColor"
                                ? props.selectedTheme?.PageStyle
                                    ?.backgroundColor
                                : subDetails.key === "SectionBackgroundColor"
                                ? props.selectedTheme?.SectionStyle
                                    ?.SectionBackColor
                                : subDetails.key === "TabBackgroundColor"
                                ? props.selectedTheme?.HorizontalTabStyle
                                    ?.BackColor
                                : subDetails.key === "WizardBackgroundColor"
                                ? props.selectedTheme?.WizardStyle
                                    ?.WizardBackgroundColor
                                : subDetails.key === "TileBackgroundColor"
                                ? props.selectedTheme?.TileStyle?.TileBackColor
                                : ""
                            }
                            handleProperty={(themeKey, arg1, arg2) =>
                              handleProperty(themeKey, arg1, arg2)
                            }
                          />
                        );
                      })}
                    </>
                  );
                })}
              </div>
            );
          })
        ) : (
          <></>
        )}
        </Col>
        </Accordion>

        <Accordion defaultExpanded classes={{ root: classes.accordionExpanded }}>
        <AccordionSummary  expandIcon={<ExpandMoreIcon />}
          classes={{ expanded: classes.accordionSummaryExpanded, root: classes.accordionSummaryRoot, content: classes.accordionSummaryContent }}
          aria-controls="panel1-content" style={accordianStyle}
          id="panel1-header">Text Style</AccordionSummary>
           <Col
        className={[style.basicThemeMainDiv].join(" ")}
      >
        {BasicThemeJson && BasicThemeJson["TextStyle"] ? (
          <div className={style.textStyleParentDiv}>
            {/* <Col
              className={style.textSizeLabelDiv}
              style={{ padding: "0px", fontSize: "14px" }}
            >
              {t("translation:Label Text Style")}
            </Col> */}
            {BasicThemeJson["TextStyle"].map((details, index) => {
              return Object.keys(details)[0] === "FontFamily" ? (
                <>
                  <DropdownComponent
                    propertyDetails={Object.values(details)[0]}
                    propertyName={Object.keys(details)[0]}
                    selectedOption={
                      props.selectedTheme &&
                      props.selectedTheme["BasicTheme"] &&
                      props.selectedTheme["BasicTheme"]["FontFamily"]
                        ? props.selectedTheme["BasicTheme"]["FontFamily"]
                        : "Open Sans"
                    }
                    selectDivStyle={{
                      display: "block",
                      margin: "16px 0px",
                      padding: "0px 15px",
                    }}
                    selectLabelStyle={{
                      width: "100%",
                      maxWidth: "100% !important",
                      font: "normal normal 300 12px Open Sans",
                      marginBottom: "8px",
                      color: "#3A3A3A",
                    }}
                    selectColumnStyle={{ minWidth: "100% !important" }}
                    selectStyle={{
                      maxWidth: "100% !important",
                      minWidth: "100%",
                      font: "normal normal 600 12px/17px Open Sans",
                      background: " #FFFFFF 0% 0% no-repeat padding-box",
                      border: "1px solid #D3D3D3",
                      borderRadius: "2px",
                    }}
                    handleProperty={(arg1, arg2) =>
                      handleChange("", arg2, arg1)
                    }
                  />
                </>
              ) : (
                <Row className={style.textSizeSelectorDiv}>
                  <Col className={style.textSizeLabelDiv}>
                    {t(`translation:${Object.values(details)[0].label}`)}
                  </Col>
                  <Col className={style.textSizeCol}>
                    <span
                      className={[style.textSizeSmall, style.textSize].join(
                        " "
                      )}
                    >
                      aA
                      <span className={style.textSizeSpanStyle}>
                        {t(`translation:(Small)`)}
                      </span>
                    </span>
                    <span
                      className={[style.textSizeedium, style.textSize].join(
                        " "
                      )}
                    >
                      aA
                      <span className={style.textSizeSpanStyle}>
                        {t(`translation:(Medium)`)}
                      </span>
                    </span>
                    <span
                      className={[style.textSizeRegular, style.textSize].join(
                        " "
                      )}
                    >
                      aA
                      <span className={style.textSizeSpanStyle}>
                        {t(`translation:(Regular)`)}
                      </span>
                    </span>
                    <span
                      className={[style.textSizeLarge, style.textSize].join(
                        " "
                      )}
                    >
                      aA
                      <span className={style.textSizeSpanStyle}>
                        {t(`translation:(Large)`)}
                      </span>
                    </span>
                  </Col>
                  <Col style={{ padding: "0px 0px 0px 4px " }}>
                    <Slider
                      value={
                        props.selectedTheme &&
                        props.selectedTheme["BasicTheme"] &&
                        props.selectedTheme["BasicTheme"]["FontSize"]
                          ? translationStyles
                            ? 27 -
                              parseInt(
                                props.selectedTheme["BasicTheme"][
                                  "FontSize"
                                ].replace("px", "")
                              )
                            : parseInt(
                                props.selectedTheme["BasicTheme"][
                                  "FontSize"
                                ].replace("px", "")
                              )
                          : "12"
                      }
                      min={12}
                      max={15}
                      onChange={handleChange}
                      track={translationStyles ? "inverted" : "normal"}
                      aria-label="continuous-slider"
                    />
                  </Col>
                </Row>
              );
            })}
          </div>
        ) : (
          <></>
        )}</Col>
        </Accordion>

        <Accordion defaultExpanded classes={{ root: classes.accordionExpanded }}>
        <AccordionSummary  expandIcon={<ExpandMoreIcon />}
           classes={{ expanded: classes.accordionSummaryExpanded, root: classes.accordionSummaryRoot, content: classes.accordionSummaryContent }}
          aria-controls="panel1-content" style={accordianStyle}
          id="panel1-header">Spacing</AccordionSummary>
           <Col
        className={[style.basicThemeMainDiv].join(" ")}
      >
        {BasicThemeJson && BasicThemeJson["Spacing"] ? (
          <div
            style={{ marginBottom: "30px",marginTop:"1px",marginLeft:"5px" }}
            className={style.textStyleParentDiv}
          >

            <RadioGroup
               aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group-spacing"
                onChange={handleSpacingType}
             >
             <FormControlLabel value="Default Spacing"
              checked={props.selectedTheme["SpacingType"] === "Default Spacing"} 
              control={<Radio  style={{color:"blue"}}  className={classes.radioroot} checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
              icon={<span className={classes.icon} />}/>} label="Default Spacing" />
             {props.selectedTheme["SpacingType"] === "Default Spacing" && BasicThemeJson["Spacing"].map((details, index) => {
              return (
                <LayoutComponent
                  styleData={details}
                  spacingTheme
                  imgStyle={{ height: "100%" }}
                  labelStyle={{ font: "normal normal 600 12px/17px Open Sans" }}
                  handleProperty={(arg1, arg2) =>
                    handleProperty("BasicTheme", arg1, arg2)
                  }
                  selectedTheme={props.selectedTheme}
                  themeKey="BasicTheme"
                  layoutDivStyle={{width:"61%"}}
                  imgDivBasicThemeStyle={{padding:"unset"}}
                  defaultSpacing
                />
              );
            })}
            <div style={{paddingTop:"16px",paddingBottom:"16px"}}>
             <FormControlLabel value="Custom Spacing"  checked={props.selectedTheme["SpacingType"] === "Custom Spacing"}
             control={<Radio  style={{color:"blue"}}  className={classes.radioroot} 
             checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
             icon={<span className={classes.icon} />}/>} label="Custom Spacing" />
             </div>
             {props.selectedTheme["SpacingType"] === "Custom Spacing" ? (
              <>
                <div style=
                {{border: "1px solid #ddd",
                      padding: "15px",
                      backgroundColor: "#fff" , marginLeft:"-7px",borderRadius:"3px"}}>
                    <h3 style={{fontFamily: 'Open Sans',
                      fontWeight: "600",
                      fontSize: "12px",
                      lineHeight: "19px",
                      marginBottom:"12px", color:"#0072C6"}}>
                      Section Spacing
                      </h3>
                <div style=
                {{
                      padding:"12px",
                      backgroundColor: "#f9f9f9",display:"flex", justifyContent:"space-between"}}>
                        <div style={{display:"flex",flexDirection:"column",gap:"12px",width:"60%"}}>
                <h5 style={{font: "normal normal 600 12px/16px Open Sans",margin:"0px"}}>Outer Padding</h5>
           
                
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Vertical Spacing</label>
                
                <div 
                style={{ display:"flex"}}
                           onMouseEnter={() => setIsHovered(true)}
                           onMouseLeave={() => setIsHovered(false)}>
                          <div className={classes.auto} style={{ backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Vertical Spacing"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Vertical Spacing","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Vertical Spacing","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>    
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between" }}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Horizontal Spacing</label>
                <div style={{ display: "flex" }} className="padding-themes-select2"
                  onMouseEnter={() => setIsHovered_h(true)}
                  onMouseLeave={() => setIsHovered_h(false)}
                >
                          <div className={classes.auto} style={{ backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Horizontal Spacing"] || defaultValue: defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Horizontal Spacing","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  className="padding-themes-select2"
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Horizontal Spacing","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                </div>
                </div>  
                </div>
                <div>
                  <SectionOuterMargin  isHovered ={isHovered} isHovered_h={isHovered_h} />
                </div>
                </div> 
                <div style={{marginTop:"9px"
                }}>
                <div style=
                {{
                      padding:"12px",
                      backgroundColor: "#f9f9f9",display:"flex",justifyContent:"space-between"}} >
                        <div style={{display:"flex",flexDirection:"column",gap:"12px",width:"60%"}}>
                <h5 style={{font: "normal normal 600 12px/16px Open Sans",margin:"0px"}}>Inner Padding</h5>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Spacing Left</label>
                <div style={{ display: "flex" }}
                  onMouseEnter={() => setisHoveredInnerleft(true)}
                  onMouseLeave={() => setisHoveredInnerleft(false)}
                >
                          <div className={classes.auto} style={{ backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Spacing Left"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Spacing Left","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Spacing Left","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                </div>
                </div>    
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Spacing Right</label>
                <div 
                  onMouseEnter={() => setisHoveredInnerright(true)}
                  onMouseLeave={() => setisHoveredInnerright(false)}
                  style={{ display: "flex" }} >
                          <div className={classes.auto} style={{ backgroundColor:"white"  }}>
                            <Autocomplete
                            freeSolo
                            classes={{ paper: classes.paper }}
                            forcePopupIcon
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Spacing Right"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Spacing Right","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Spacing Right","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>  
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Spacing Top</label>
                <div style={{ display: "flex" }}
                  onMouseEnter={() => setisHoveredInnertop(true)}
                  onMouseLeave={() => setisHoveredInnertop(false)}
                >
                          <div className={classes.auto} style={{ backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Spacing Top"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Spacing Top","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Spacing Top","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>   
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Spacing Bottom</label>
                <div onMouseEnter={() => setisHoveredInnerbottom(true)}
                    onMouseLeave={() => setisHoveredInnerbottom(false)} 
                    style={{ display: "flex" }}
                >
                          <div className={classes.auto} style={{ backgroundColor:"white"}}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Spacing Bottom"]  || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Spacing Bottom","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Section Spacing",event?.target?.value,"Spacing Bottom","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div> 
                </div> 
                <div style={{
                      // paddingTop:"21%",
                      display:"flex",
                      flexDirection:"column",
                      justifyContent:"center"
                    }}
                >
                  <div>
                    <SectionInnerPadding  
                      isHoveredInnerleft={isHoveredInnerleft}
                      isHoveredInnerright={isHoveredInnerright}
                      isHoveredInnertop={isHoveredInnertop}
                      isHoveredInnerbottom={isHoveredInnerbottom} 
                    />
                  </div>
                  </div>   
                </div>  
                </div> 
                </div>  
                <div style=
                {{border: "1px solid #ddd",
                      padding: "15px",
                      marginTop:"11px",
                      backgroundColor: "#fff",marginLeft:"-5px",borderRadius:"3px",marginBottom: "37px"}}>
                    <h3 style={{fontFamily: 'Open Sans',
                      fontWeight: "600",
                      fontSize: "12px",
                      marginBottom:"12px", color:"#0072C6",
                      lineHeight: "19px"}}>Control Spacing</h3>              
                <div style={{
                padding:"12px",
                backgroundColor: "#f9f9f9"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div style={{display:"flex",flexDirection:"column",gap:"12px",width:"60%"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Spacing Left</label>
                <div onMouseEnter={() => setisHovspacingleft(true)}
                    onMouseLeave={() => setisHovspacingleft(false)}
                     style={{ display: "flex"}}>
                          <div className={classes.auto} style={{backgroundColor:"white"  }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                              value={props?.selectedTheme?.["Control Spacing"] ? props?.selectedTheme?.["Control Spacing"]["Spacing Left"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Control Spacing",event?.target?.value,"Spacing Left","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Control Spacing",event?.target?.value,"Spacing Left","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>    
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Spacing Right</label>
                <div onMouseEnter={() => setisHovspacingright(true)}
                    onMouseLeave={() => setisHovspacingright(false)} style={{ display: "flex"}}>
                          <div className={classes.auto} style={{ backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                              value={props?.selectedTheme?.["Control Spacing"] ? props?.selectedTheme?.["Control Spacing"]["Spacing Right"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Control Spacing",event?.target?.value,"Spacing Right","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Control Spacing",event?.target?.value,"Spacing Right","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>  
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Spacing Top</label>
                <div onMouseEnter={() => setisHovspacingtop(true)}
                    onMouseLeave={() => setisHovspacingtop(false)} style={{ display: "flex" }}>
                          <div className={classes.auto} style={{ backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["Control Spacing"] ? props?.selectedTheme?.["Control Spacing"]["Spacing Top"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Control Spacing",event?.target?.value,"Spacing Top","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Control Spacing",event?.target?.value,"Spacing Top","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>   
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <label style={{font: "normal normal 400 12px/16px Open Sans",margin:"0px"}}>Spacing Bottom</label>
                <div onMouseEnter={() => setisHovspacingbottom(true)}
                    onMouseLeave={() => setisHovspacingbottom(false)}  style={{ display: "flex", }}>
                          <div className={classes.auto} style={{backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            classes={{ paper: classes.paper }}
                            popupIcon={<KeyboardArrowDownIcon />}
                              value={props?.selectedTheme?.["Control Spacing"] ? props?.selectedTheme?.["Control Spacing"]["Spacing Bottom"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={BasicThemeJson["Custom Spacing"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                handleProperty("BasicTheme", "Control Spacing",event?.target?.value,"Spacing Bottom","Custom Spacing")
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  // type="number"
                                  onBlur={(event, value) =>
                                    handleProperty("BasicTheme", "Control Spacing",event?.target?.value,"Spacing Bottom","Custom Spacing")
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
               </div>
                </div>   
                </div>   
                <div style={{
                      // marginLeft:"20%", 
                      display:"flex", 
                      flexDirection:"column", 
                      justifyContent:"center"
                    }}
                >    
                  <div >
                    <ControlSpacing  
                       isHovspacingleft={isHovspacingleft}
                       isHovspacingright={isHovspacingright}
                       isHovspacingtop={isHovspacingtop}
                       isHovspacingbottom={isHovspacingbottom}
                    />
                  </div>   
                  </div>
                </div>
                </div>
                </div>                                               
              </>
             ): null}
             </RadioGroup>
             
          </div>
        ) : (
          <></>
        )}
         </Col>
        </Accordion>
      {showColorPalleteEditable === true ? (
        <EditableColorPallete
          key={showColorPalleteEditable}
          colorPalleteColors={
            props?.selectedTheme &&
            props?.selectedTheme?.["BasicTheme"] &&
            props?.selectedTheme?.["BasicTheme"]["colorPallete"]
              ? props?.selectedTheme?.["BasicTheme"]["colorPallete"]
              : colorPalleteColors
          }
          handleBackdrop={(action, actionObj) =>
            handleBackdrop(action, actionObj)
          }
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default BasicTheme;
